import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const SiteContext = createContext(null);

const FALLBACK = {
    settings: {
        brand: { name: "LovinLife", tagline: "Lovin life", logo_url: "", logo_initial: "L" },
        announcement: { enabled: false, text: "", link: "/" },
        contact: { email: "hello@lovinlife.com", instagram: "@lovinlife", instagram_url: "#" },
        footer: { blurb: "", rights: "All rights reserved.", tagline: "" },
        nav_links: [
            { label: "Clothing", to: "/shop?cat=clothing" },
            { label: "Home", to: "/shop?cat=home" },
            { label: "Office", to: "/shop?cat=office" },
            { label: "All", to: "/shop" },
        ],
        footer_pages: [],
    },
    blocks: {},
    pages: [],
};

export function SiteProvider({ children }) {
    const [data, setData] = useState(FALLBACK);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data: site } = await api.get("/site");
            setData({
                settings: { ...FALLBACK.settings, ...(site.settings || {}) },
                blocks: site.blocks || {},
                pages: site.pages || [],
            });
        } catch (e) {
            // keep fallback
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return <SiteContext.Provider value={{ ...data, loading, refresh }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext) || { ...FALLBACK, loading: false, refresh: () => {} };

// Helper to read a block with safe defaults
export function useBlock(key, defaults = {}) {
    const { blocks } = useSite();
    return { ...defaults, ...(blocks[key] || {}) };
}
